// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__chuVP","loaderOuter":"PageOverlayLoader_loaderOuter__28btq"};